document.addEventListener("scroll", () => {
  const header = document.querySelector(".header--transparent");
  if (!header) return;

  if (window.scrollY > 50) {
    header.classList.add("header--scrolled");
  } else {
    header.classList.remove("header--scrolled");
  }
});